/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Checkbox, CheckboxChangeParams, Icon, Tooltip } from '@marketplace/ui-elements';
import type { TApplicationScope, TTechDetails } from '@marketplace/api';
import classes from './scopes-item.module.scss';
import { Control, UseFormSetValue } from 'react-hook-form';
import { mockedFormatMessageI18n } from '@marketplace/common';

export type TScopesItemProps = {
  scope: TApplicationScope;
  checkedScope: 'individual' | 'population' | 'system';
  isDisabled: boolean;
  control: Control<TTechDetails>;
  setValue: UseFormSetValue<TTechDetails>;
  scopeList: TApplicationScope[];
  clearErrors?: any;
  trigger?: any;
  hint?: string;
};

export const ScopesItem = ({
  scope,
  checkedScope,
  isDisabled,
  control,
  setValue,
  scopeList,
  clearErrors,
  hint,
}: TScopesItemProps) => {
  const getCurrentScopeState = (
    checkedScope: 'individual' | 'population' | 'system'
  ) => {
    if (checkedScope === 'individual') {
      return {
        isRead: scope?.individual_patient_r,
        isWrite: scope?.individual_patient_w,
        read: 'individual_patient_r',
        write: 'individual_patient_w',
      };
    }

    if (checkedScope === 'population') {
      return {
        isRead: scope?.patient_population_r,
        isWrite: scope?.patient_population_w,
        read: 'patient_population_r',
        write: 'patient_population_w',
      };
    }

    return {
      isRead: scope?.system_r,
      isWrite: scope?.system_w,
      read: 'system_r',
      write: 'system_w',
    };
  };

  const { read, write, isRead } = getCurrentScopeState(checkedScope);

  const handleScope = (e: CheckboxChangeParams, type: string) => {
    const key = type === 'read' ? read : write;
    const isExist = !!scopeList.find((i) => i.id === scope.id);
    clearErrors('scopes')


    if (e.checked && !isExist) {
      setValue('scopes', [...scopeList, { id: scope.id, [key]: e.checked }], {
        shouldDirty: true,
        shouldValidate: true,
      });
    }
    if (e.checked && isExist) {
      const newScope = scopeList.map((i) =>
        i.id === scope.id ? { ...i, [key]: true } : i
      );
      setValue('scopes', newScope, {
        shouldDirty: true,
        shouldValidate: true,

      });
    }
    if (!e.checked) {
      const newScope = scopeList.map((i) =>
        i.id === scope.id ? { ...i, [key]: false } : i
      );
      setValue('scopes', newScope, {
        shouldDirty: true,
        shouldValidate: true,

      });
    }
  };

  return (
    <div className={classes.scopesListItem}>
      <Checkbox
        rootClassName={classes.readCheckboxCell}
        fieldId={`scope_${scope?.name}_read`}
        name="scopes"
        disabled={isDisabled || !isRead}
        control={control}
        onChange={(e) => handleScope(e, 'read')}
        checked={
          //@ts-ignore
          scopeList && !!scopeList?.find((i) => i.id === scope.id && i[read])
        }
      />
      

      <div className={classes.scopesCell}>{scope?.name}
        {hint && (
          <span className="margin-l5">
            <Icon iconClassName={`${scope?.name}Hint`} size={Icon.sizes.medium} glyph={Icon.glyphs.svg['information']} />
            <Tooltip target={`.${scope?.name}Hint`}>
              {mockedFormatMessageI18n({
                id: hint,
              })}
            </Tooltip>
          </span>
        )}
      </div>
    </div>
  );
};
